import clsx from 'clsx';
import { FadeIn } from 'components/common/FadeIn';
import Link from 'next/link';
import styles from './Trees.module.css';

const TreesHeaderText = ({ isMobile }: { isMobile?: boolean }) => {
  return (
    <div className={styles.treesHeaderText}>
      <FadeIn onScroll className={styles.introHeader}>
        <p className="daymadeTypographyTaglineAccent">More than prizes</p>
        <h2 className={clsx('daymadeTypographyXL', styles.title)}>
          Every purchase {isMobile ? <br /> : null}plants a tree
        </h2>
      </FadeIn>
      <FadeIn onScroll delay={0.2}>
        <p className={clsx('daymadeTypographyMRegular', styles.description)}>
          Make a difference for our planet. Trees are planted, tracked and
          verified across 4 countries with local partners.{' '}
          <Link
            className={clsx('daymadeTypographyMRegular', styles.learnMore)}
            href="/giving-back"
          >
            Learn more
          </Link>
        </p>
      </FadeIn>
    </div>
  );
};

export default TreesHeaderText;
